import React from 'react';
import DateHelper from '../../DateHelper/DateHelper'
import clsx from "clsx";
import {format} from "date-fns"
import numeral from "numeral"


export default class RatePresenterGeneral extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00',
      dateFormat: DateHelper.rubyToDateFNS(this.props.date_format),
      timeFormat: DateHelper.rubyToDateJS(this.props.time_format),
    }
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true,
      'container': true,
    });


    return (
      <div className={tabClasses} id="general">
        <div className="row">
          <div className="col-sm-2">
            <div className="form-group">
              <label>{`${I18n.t('code')}*`}</label>
              <div>{this.props.code}</div>
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <label>{I18n.t('name')}</label>
              <div>{this.props.name}</div>
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <label>{I18n.t('rate_type')} <span className="ss-help help" title={I18n.t('rate_type_helper_text')}></span></label>
              <div>{I18n.t(this.props.rate_type)}</div>
            </div>
            {
              this.props.rate_type === 'special'
              ?
              <div className="form-group">
                <label>{I18n.t('hidden')} <span className="ss-help help" title={I18n.t('hidden_special_rate_helper_text')}></span></label>
                <div>{I18n.t(this.props.is_hidden ? 'yes' : 'no')}</div>
              </div>
              :
              null
            }
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <label>{I18n.t('status')}</label>
              <div>{I18n.t(this.props.status)}</div>
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <label>{I18n.t('check_in_time_override')}</label>
              <div>{this.props.check_in_time ? DateHelper.printDateToScreen(new Date(this.props.check_in_time), this.props.time_format, true) : null}</div>
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <label>{I18n.t('check_out_time_override')}</label>
              <div>{this.props.check_out_time ? DateHelper.printDateToScreen(new Date(this.props.check_out_time), this.props.time_format, true) : null}</div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-2">
            <div className="form-group">
              <label style={{textTransform: 'capitalize'}}>{I18n.t('min_stay')} <span className="ss-help help" title={I18n.t('rate_min_stay_helper_text')}></span></label>
              <div>{this.props.minimum_stay}</div>
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <label>{I18n.t('max_stay')} <span className="ss-help help" title={I18n.t('rate_max_stay_helper_text')}></span></label>
              <div>{this.props.maximum_stay}</div>
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <label>{I18n.t('min_lead')} <span className="ss-help help" title={I18n.t('rate_min_lead_helper_text')}></span></label>
              <div>{this.props.minimum_lead}</div>
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <label>{I18n.t('max_lead')} <span className="ss-help help" title={I18n.t('rate_max_lead_helper_text')}></span></label>
              <div>{this.props.maximum_lead}</div>
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <label>{I18n.t('start_booking_date')} <span className="ss-help help" title={I18n.t('rate_start_booking_date_helper_text')}></span></label>
              {
                this.props.start_booking_date
                  ?
                <div>{format(this.props.start_booking_date, this.state.dateFormat)}</div>
                  :

                null
              }
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <label>{I18n.t('end_booking_date')} <span className="ss-help help" title={I18n.t('rate_end_booking_date_helper_text')}></span></label>
              {
                this.props.end_booking_date
                  ?
                  <div>{format(this.props.end_booking_date, this.state.dateFormat)}</div>
                  :
                null
              }
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('short_description')} <span className="ss-help help" title={I18n.t('rate_short_description_helper_text')}></span></label>
              <div>{this.props.short_description}</div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('long_description')} <span className="ss-help help" title={I18n.t('long_description_helper_text')}></span></label>
              <div>{this.props.long_description}</div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="panel panel-default" style={{marginBottom: 0}}>
              <div className="panel-body container">
                {this.renderAmountPercentageForm()}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderAmountPercentageForm() {
    if (this.props.amount) {
      return (
        <div>
          <h5 className="panel-heading-text" style={{borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 0, marginTop: 0}}>{I18n.t('base_price_override')} <span className="ss-help help" title={I18n.t('standard_rate_override_helper_text')}></span></h5>
          <div>${numeral(this.props.amount / 100).format(this.state.numberFormat)}</div>
        </div>
      )
    } else if (this.props.percentage) {
      return (
        <div>
          <h5 className="panel-heading-text" style={{borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 0, marginTop: 0}}>{I18n.t('base_price_override')} <span className="ss-help help" title={I18n.t('standard_rate_override_helper_text')}></span></h5>
          <div>{this.props.percentage * 100}%</div>
        </div>
      )
    } else {
      return (
        <div>
          <h5 className="panel-heading-text" style={{borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 0, marginTop: 0}}>{I18n.t('base_price_override')} <span className="ss-help help" title={I18n.t('standard_rate_override_helper_text')}></span></h5>
          <div><span className="none">{I18n.t('none')}</span></div>
        </div>
      )
    }
  }

}
